import { breakpoints, Button, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 8px;
  padding: 20px;

  @media (min-width: ${breakpoints.md}) {
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    gap: 12px;
    padding: 52px 32px;
  }

  button > img {
    display: block;
    object-fit: cover;
    border-radius: 8px;
    width: 100%;
    aspect-ratio: 1;
    background-color: ${theme.color.background.tertiary};
  }
`;

export const GridImageButton = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
`;

export const GridImageSkeleton = styled.div`
  border-radius: 8px;
  width: 100%;
  aspect-ratio: 1;
  background-color: ${theme.color.background.tertiary};
`;

export const ReviewPhotoModalHeader = styled.div`
  padding: 0.25rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${theme.color.border.divider};

  display: none;
  @media (min-width: ${breakpoints.md}) {
    display: block;
  }
`;

export const BackButton = styled(Button)`
  border: none !important;
  padding-inline: 0.75rem !important;
`;
